import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import toast from 'react-hot-toast';
import AuthGuard from '../components/AuthGuard';
import { api } from '../lib/api';

export default function NewIdCard() {
  const navigate = useNavigate();
  const [hasApplied, setHasApplied] = useState(false);
  const [submitting, setSubmitting] = useState(false);

  useEffect(() => {
    Promise.all([
      api.get('/party-amnesty/status'),
      api.get('/hukou/status'),
      api.get('/id-card/status'),
    ]).then(([partyRes, hukouRes, idCardRes]) => {
      if (!partyRes.data.has_applied) {
        navigate('/party-amnesty', { replace: true });
        return;
      }
      if (!hukouRes.data.has_registered) {
        navigate('/household-registration', { replace: true });
        return;
      }
      if (idCardRes.data.has_applied) {
        navigate('/new-id-card-result', { replace: true });
        return;
      }
    }).catch(() => { });
  }, []);

  async function handleSubmit() {
    if (hasApplied || submitting) return;
    setSubmitting(true);
    try {
      await api.post('/id-card');
      toast.success('提交成功');
      navigate('/new-id-card-result', { replace: true });
    } catch (e: any) {
      toast.error(e?.response?.data?.message || '提交失败');
    } finally {
      setSubmitting(false);
    }
  }

  const steps = ['提交申请', '资料审核', '审核通过', '办理落户', '领取证件'];

  const benefits = [
    { title: '落户新户口', desc: '合法落户新户籍' },
    { title: '摆脱黑户记录', desc: '清除不良记录' },
    { title: '新二代身份证', desc: '领取新身份证件' },
    { title: '享受居民权益', desc: '享受合法权益' },
  ];

  const conditions = [
    '年满18周岁的中国公民',
    '持有有效身份证明材料',
    '无重大刑事犯罪记录',
    '符合当地落户政策要求',
  ];

  const materials = [
    '身份证原件',
    '户口注销证明',
    '无犯罪证明',
    '近期证件照',
    '申请表格',
  ];

  return (
    <div className="max-w-md mx-auto min-h-screen bg-[#f5f5f5] pb-10 relative w-[448px]">
      <AuthGuard />

      {/* Hero Section */}
      <div className="relative">
        <button
          onClick={() => navigate(-1)}
          className="absolute top-3 left-3 z-10 w-8 h-8 flex items-center justify-center rounded-full bg-white/50 text-black/80"
        >
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><path d="M15 18l-6-6 6-6" /></svg>
        </button>

      </div>

      {/* ID Card Preview */}
      <div className="relative">
        <img src="/images/shenfenzheng.png" alt="身份证预览" className="w-full" />
      </div>

      {/* Submit Button */}
      <div className="absolute bottom-[180px] text-center w-full max-w-md mx-auto ">
        {hasApplied ? (
          <div className="w-full bg-green-50 text-green-700 font-bold text-center py-4 rounded-full text-sm">
            已申请（审核中）
          </div>
        ) : (
          <button
            onClick={handleSubmit}
            disabled={submitting}
            className="w-full"
          >
            <img src={"/images/shenfenzheng_button.png"} alt="shenfenzheng_button" className="w-[300px] mx-auto" />
          </button>
        )}
      </div>

      {/* Bottom Trust */}
      <div className="mx-4 mt-4 mb-6">
        <div className="flex justify-center gap-6 text-[10px] text-gray-400">
          <div className="flex items-center gap-1">
            <svg width="10" height="10" viewBox="0 0 24 24" fill="currentColor"><path d="M18 8h-1V6c0-2.76-2.24-5-5-5S7 3.24 7 6v2H6c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V10c0-1.1-.9-2-2-2zm-6 9c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2zm3.1-9H8.9V6c0-1.71 1.39-3.1 3.1-3.1 1.71 0 3.1 1.39 3.1 3.1v2z" /></svg>
            <span>信息加密</span>
          </div>
          <div className="flex items-center gap-1">
            <svg width="10" height="10" viewBox="0 0 24 24" fill="currentColor"><path d="M12 1L3 5v6c0 5.55 3.84 10.74 9 12 5.16-1.26 9-6.45 9-12V5l-9-4z" /></svg>
            <span>官方认证</span>
          </div>
          <div className="flex items-center gap-1">
            <svg width="10" height="10" viewBox="0 0 24 24" fill="currentColor"><path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41L9 16.17z" /></svg>
            <span>安全可靠</span>
          </div>
        </div>
      </div>
    </div>
  );
}
